import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { Router, ActivatedRoute, NavigationEnd, PRIMARY_OUTLET } from '@angular/router';
import { Location, LocationStrategy } from '@angular/common';
import { CrumbItem } from '../models';

@Injectable({
    providedIn: 'root'
})
export class CrumbCacheService {
    private _items: CrumbItem[] = [];
    private count: number = 0;

    _crumbs$: Subject<CrumbItem[]> = <Subject<CrumbItem[]>>new Subject();
    get crumbs$() { return this._crumbs$ };

    public getCrumbs(): void {
        this._crumbs$.next(this._items);
    }

    constructor(private router: Router,
        private activatedRoute: ActivatedRoute,
        private location: Location,
        private locationStrategy: LocationStrategy) {

        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            let root: ActivatedRoute = this.activatedRoute.root;
            this.buildCrumbs(root);
            this._crumbs$.next(this._items);
        });

    }

    private buildCrumbs(route: ActivatedRoute, routerLink: string = ''): void {

        let child = route.children.find((route) => route.outlet === PRIMARY_OUTLET);
        if (child) {
            let childURL = child.snapshot.url.map(segment => segment.path).join("/");
            if (childURL && childURL.length > 0)
                routerLink += `/${childURL}`;

            this.buildCrumbs(child, routerLink);
        }
        else {
            // if we route home, we reset the crumb trail
            if (routerLink === '/home') {
                this._items = [];
            }
            // Other routerLinks will be grafted or appended base on if 
            // it already exists in the tree and if it's parent is 'sticky'
            else {
                let foundIndex: number = this._items.findIndex(x => x.routerLink === routerLink);
                // If this link is already in the trail just update it and prune
                if (foundIndex >= 0) {
                    this._items = this._items.slice(0, foundIndex + 1);
                    this._items[foundIndex].queryParams = route.snapshot.queryParams;
                }
                // otherwise we'll append it or replace the last crumb if it shared a menu
                else {
                    let crumb: CrumbItem = {
                        label: route.snapshot.data['breadcrumb'],
                        menuDef: route.snapshot.data['menuDef'],
                        sticky: route.snapshot.data['sticky'],
                        routerLink: routerLink,
                        queryParams: route.snapshot.queryParams,
                    };

                    // If the last crumb's menu exists and matches this crumb's menu, we replace it
                    let lastCrumbIndex = this._items.length - 1;
                    if (
                        lastCrumbIndex >= 0 &&
                        crumb.menuDef &&
                        crumb.menuDef.length > 0 &&
                        crumb.menuDef === this._items[lastCrumbIndex].menuDef &&
                        this._items[lastCrumbIndex].sticky !== true
                    ) {
                        this._items[lastCrumbIndex] = crumb;
                    }
                    // Otherwise we append a newcrumb
                    else {
                        this._items.push(crumb);
                    }
                }

            }
        }
    }

    public relabelCrumb(crumbLabel: string, crumbName: string): void {
        let crumb = this._items.find(x => x.label === crumbLabel)
        if (crumb) {
            crumb.label = crumbName;
            this._crumbs$.next(this._items);
        }
    }
}
